import { render, staticRenderFns } from "./inspect.vue?vue&type=template&id=2f1d2dac&scoped=true&"
import script from "./inspect.vue?vue&type=script&lang=js&"
export * from "./inspect.vue?vue&type=script&lang=js&"
import style0 from "./inspect.vue?vue&type=style&index=0&id=2f1d2dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d2dac",
  null
  
)

export default component.exports